import React from "react";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import EmptyDataView from "../../../../components/nodataview";
import emptyLspIcon from "../../../../assets/images/no-lsp.png";
import CustomeButton from "../../../../components/Button";

const LspLists = ({
  data,
  handleAddNewLsp,
  onPageChange,
  lsplistpage,
  lsplistlimit,
}) => {
  // const handleCountry = (rowData) => {
  //   const countryCodes = Array.from(
  //     new Set(rowData?.access.map((item) => item.entity.country))
  //   );
  //   return countryCodes
  //     ?.map((countryCode) => {
  //       const countryName = getName(countryCode);
  //       return (
  //         <span key={countryCode} className="flex align-items-center mr-2 mt-1">
  //           <ReactCountryFlag countryCode={countryCode} svg className="mr-2" />
  //           {countryName}
  //         </span>
  //       );
  //     })
  //     ?.reduce((prev, curr) => [prev, " ", curr]);
  // };

  const handleCountry = (rowData) => {
    const countryCodes = Array.from(
      new Set(rowData?.access.map((item) => item.entity.country)),
    );

    const countries = countryCodes?.map((countryCode) => {
      const countryName = getName(countryCode);
      return (
        <React.Fragment key={countryCode}>
          <ReactCountryFlag countryCode={countryCode} svg className="mr-1" />
          {countryName}
        </React.Fragment>
      );
    });
    const maxDisplay = 3;
    if (countries.length > maxDisplay) {
      return [
        ...countries
          .slice(0, maxDisplay)
          .reduce((prev, curr) => [prev, ",\u00A0", curr]),
        ",\u00A0...",
      ];
    }
    return countries.length > 0
      ? countries?.reduce((prev, curr) => [prev, ",\u00A0", curr])
      : "";
  };
  return (
    <>
      {!data ? (
        <DataTable
          value={Array(6).fill({})}
          tableStyle={{ minWidth: "100%" }}
          className="datatable-right-align"
          rows={6}
        >
          <Column header="Trading Name" body={<Skeleton />} />
          <Column header="Countries" body={<Skeleton />} />
          <Column header="Services" body={<Skeleton />} />
          <Column header="Account Manager" body={<Skeleton />} />
          <Column />
        </DataTable>
      ) : data && data.length > 0 ? (
        <DataTable
          value={data || []}
          sortMode="multiple"
          tableStyle={{ minWidth: "50rem" }}
          paginator={data?.length > 10}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          rowsPerPageOptions={[10, 20, 30]}
          className="datatable-right-align"
          emptyMessage="No results were found"
          first={lsplistpage}
          rows={lsplistlimit}
          onPage={onPageChange}
        >
          <Column
            field="name"
            header="Trading Name"
            sortable
            body={(rowData) => (
              <Link className="entity-link" to={`/lsp/${rowData.id}/dashboard`}>
                {rowData.name}
              </Link>
            )}
          />
          <Column
            sortable
            header="Countries"
            field="countries"
            body={handleCountry}
          />
          <Column
            sortable
            header="Services"
            field="services"
            body={(rowData) => {
              const serviceNames = Array.from(
                new Set(
                  rowData?.access.flatMap((item) =>
                    item.services.map((service) => service.name),
                  ),
                ),
              ).sort();
              return serviceNames.join(", ");
            }}
          />
          <Column
            field="account_manager_name"
            header="Account Manager"
            sortable
          />
        </DataTable>
      ) : (
        <div className="p-5 m-5 flex flex-column justify-content-center align-items-center">
          <EmptyDataView
            Icon={
              <img
                className="users-card-icon-img"
                src={emptyLspIcon}
                alt="Users Icon"
              />
            }
            Header={"No partners registered yet"}
            Description={"Let's add your first one"}
          />
          <CustomeButton
            label="Add New"
            icon="pi pi-plus"
            variant="contained"
            iconPos="right"
            onClick={handleAddNewLsp}
          />
        </div>
      )}
    </>
  );
};

LspLists.propTypes = {
  data: PropTypes.array,
  handleAddNewLsp: PropTypes.func,
  onPageChange: PropTypes.func,
  lsplistpage: PropTypes.number,
  lsplistlimit: PropTypes.number,
};
export default LspLists;
